import { render } from "./indexninefeedback.vue?vue&type=template&id=5f88ef4e&scoped=true"
import script from "./indexninefeedback.vue?vue&type=script&lang=js"
export * from "./indexninefeedback.vue?vue&type=script&lang=js"

import "./indexninefeedback.vue?vue&type=style&index=0&id=5f88ef4e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f88ef4e"]])

export default __exports__